import * as React from 'react';
import { Button,  } from 'antd';
import { Table } from 'antd';
import strings from '../../eyeguide-localization/customer/string.customer.add';
import userStrings from '../../eyeguide-localization/user/string.user.addedit';
import '../../css/ContentThree.scss';
import Utils from '../common/utils';

/**
 * Property definition
 */
interface IContentThreeProps {
    handleSaveClick: any;
    handlePrevClick: any;
    customer: any;
    account: any;
}

/**
 * State definition
 */
interface IContentThreeState {
    customer: any;
    account: any;
    emptyText: any;
    columns: Array<any>;
    columnData:  Array<any>;
    userColumnData:  Array<any>;
    loading: boolean;
}

export default class ContentThree extends React.Component<IContentThreeProps, IContentThreeState> {

    constructor(props: IContentThreeProps) {
        super(props);
        this.state = {
            customer: [],
            account: [],
            emptyText: 'No Data',
            columns: [],
            columnData: [],
            userColumnData: [],
            loading: true
        };
    }

    componentDidMount() {
        Utils.resetScroll();
        this.componentWillReceiveProps(this.props);
    }

    componentWillReceiveProps(nextProps: any) {
        this.setState({
            columnData: this.buildOrgData(nextProps.customer),
            userColumnData: this.buildUserData(nextProps.account),
            customer: nextProps.customer,
            account: nextProps.account,
            columns: this.buildColumns(),
            loading: false
        });
    }

    render() {
        return (
            <div className="ContentThree">
                <table className="table">
                <tr><td colSpan={2}>
                    <Table 
                    
                        columns={this.state.columns} 
                        dataSource={this.state.columnData} 
                        pagination={false}
                        rowKey={record => record.uid}
                        loading={this.state.loading}
                        rowClassName={(record, index) => 'rows'}
                        expandRowByClick={true}
                        locale={{ emptyText: this.state.emptyText }} 
                        bordered={true}
                        title={() => <h2>Customer Details</h2>}
                    />
                    </td></tr>
                    <tr> <td colSpan={2} style={{paddingTop: '20px'}}/> </tr>
                    <tr><td colSpan={2}>
                    <Table 
                        columns={this.state.columns} 
                        dataSource={this.state.userColumnData} 
                        pagination={false}
                        rowKey={record => record.uid}
                        loading={this.state.loading}
                        rowClassName={(record, index) => 'rows'}
                        expandRowByClick={true}
                        locale={{ emptyText: this.state.emptyText }} 
                        bordered={true}
                        title={() => <h2>Account Details</h2>}
                    />
                    
                     </td></tr>
                     <tr> <td style={{paddingTop: '20px'}}/> </tr>
                    {/* <Row className="buttonRow">
                    <Col span={12} >
                            <div className="buttonRight">  */}
                            <tr>
                                <td className="buttonTd">
                            <Button
                                type="primary"
                                onClick={e => this.props.handleSaveClick()}
                            >
                            {strings.lsAddTxt} 
                            </Button>
                                </td>
                            {/* </div>
                    </Col>
                        <Col span={12}> */}
                            {/* <div className="buttonLeft">  */}
                            <td>
                            <Button
                                onClick={e => this.props.handlePrevClick(2)} 
                            >
                            {userStrings.lsPrevTxt} 
                            </Button>
                                </td>
                                </tr>
                            {/* </div> */}
                        {/* </Col>
                    </Row> */}
                </table>
            </div>
        );
    }

    private buildOrgData(customer: any) {
        let columnData: Array<any> = [];
        let orgs = this.formOrgDataToDisplay(customer);
        orgs.forEach( (element: any) => {
            let data = {
                name: element.name,
                value: element.value,
            };
            columnData.push(data);
        }); 
        return columnData;
    }

   private buildUserData(account: any) {
       let columnData: Array<any> = [];
       let users = this.formUserDataToDisplay(account);
       users.forEach( (element: any) => {
           let data = {
               name: element.name,
               value: element.value,
           };
           columnData.push(data);
       }); 
       return columnData;
   }
  
    /**
     * This function returns the column setting for use with the Table component
     */
    private buildColumns() {
        let columns = [
          {
            title: strings.lsNameTxt,
            dataIndex: 'name',
            className: 'rows',
            width: 200,
          },
          {
            title: strings.lsValueTxt,
            dataIndex: 'value',
          }
        ];
        return columns;
    }

    private formOrgDataToDisplay(customer: any) {
        let data = [{
                name: strings.lsOrgName,
                value: customer.name
            },
            {
                name: strings.lsOrgEmailTxt,
                value: customer.email
            },
            {
                name: strings.lsWebsiteTxt,
                value: customer.website
            },
            {
                name: strings.lsAddressTxt,
                value: customer.address
            },
            {
                name: strings.lsCityTxt,
                value: customer.city
            },
            {
                name: strings.lsStateTxt,
                value: customer.state
            },
            {
                name: strings.lsCountryTxt,
                value: customer.country
            },
            {
                name: strings.lsZipPostalCodeTxt,
                value: customer.pincode
            },
            {
                name: strings.lsContactFirstNameTxt,
                value: customer.contactfirstname
            },
            {
                name: strings.lsContactLastNameTxt,
                value: customer.contactlastname
            },
            {
                name: strings.lsContactPhoneTxt,
                value: customer.contactphone
            },
            {
                name: strings.lsContactEmailTxt,
                value: customer.contactemail
            },
            {
                name: strings.IsTestTags,
                value: customer.testtags
            },
            {
                name: strings.IsPrivacyEnabled,
                value: customer.enableprivacy ? 'Yes' : 'No'
            },
            {
                name: strings.IsViewInAppTestTxt,
                value: customer.viewinapptest ? 'Yes' : 'No'
            },
            {
                name: strings.IsViewInAppBaseline,
                value: customer.viewinappbaseline ? 'Yes' : 'No'
            },
            {
                name: strings.lsEnableBestBaseline,
                value: customer.enablebestbaseline ? 'Yes' : 'No'
            },
            {
                name: strings.lsEnableFailedTestReport,
                value: customer.enablefailedtestreport ? 'Yes' : 'No'
            }
        ];
        return data;
    }

    private formUserDataToDisplay(account: any) {
        let data = [{
                name: userStrings.lsUsrNameTxt,
                value: account.username
            },
            {
                name: userStrings.lsFNameTxt,
                value: account.firstname
            },
            {
                name: userStrings.lsLNameTxt,
                value: account.lastname
            },
            {
                name: userStrings.lsEmailTxt,
                value: account.email
            },
            {
                name: userStrings.lsMobilePhTxt,
                value: account.phone
            }
        ];
        return data;
    }
}


// WEBPACK FOOTER //
// ./src/components/customer/ContentThree.tsx